import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../../layout/AppLayout";
import {
  Arrow,
  FundBank,
  FundCard,
  FundPhone,
} from "../../../components/svg/Wallet/Wallet";
import { Card } from "../../../components/Card";
import { BiChevronDown } from "react-icons/bi";

const FundWalletVia = [
  {
    name: "Bank Transfer",
    type: "transfer",
    description: "Send money directly from your bank account.",
    path: "/settings/wallet/fund/bank-transfer",
  },
  {
    name: "Credit/Debit Card",
    type: "card",
    description: "Use your card for instant, secure payments.",
    path: "/settings/wallet/fund/card-topup",
  },
  {
    name: "USSD Code",
    type: "ussd",
    description: "Dial a code to fund without internet access.",
    path: "/settings/wallet/fund/ussd",
  },
];

export const FundWallet = () => {
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className=" min-h-screen px-4 pt-10">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate(-1)}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer  "
          />
          <p className="font-bold text-xl text-primary-black">Fund Wallet</p>
        </div>
        <div className="mt-10 flex flex-col gap-5">
          {FundWalletVia?.map((x, i) => {
            return (
              <Card
                onClick={() => navigate(x.path)}
                key={i}
                className="flex items-center justify-between gap-3 !py-2.5 !pl-2.5 !pr-7 cursor-pointer"
              >
                <div className="flex items-center gap-2.5">
                  {x.type === "transfer" ? (
                    <FundBank />
                  ) : x.type === "card" ? (
                    <FundCard />
                  ) : (
                    <FundPhone />
                  )}

                  <div>
                    <p className="text-base font-semibold text-primary-black mb-1">
                      {x.name}
                    </p>
                    <p className="text-xs font-medium text-[#00000080] leading-tight">
                      {x.description}
                    </p>
                  </div>
                </div>

                <BiChevronDown className="-rotate-90 text-[#00000080]" />
              </Card>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
};
